class AusList extends Tango.Component {
	widgetDidMount() {
		var fields = document.getElementsByClassName("number");
		for (var i = 0; i < fields.length; i++) {
			fields[i].addEventListener("input", function (evt) {
				var userVal = evt.target.value;
				var digits = evt.target.getAttribute("data-digits");
				var regex = new RegExp('^\\d+\\.?(\\d?){' + digits + '}$');
				if (!regex.test(userVal)) {
					regex = new RegExp('^\\d+\\.?(\\d?){' + digits + '}');
					var val = userVal.replace(',', '.').replaceAll(/[^0-9.]/g, '');
					var m = val.match(regex);
					if (m) {
						userVal = m[0];
						//setProp(parseFloat(userVal), true);

					}
					else {
						userVal = '';
						//setProp(null, true);
					}
					evt.target.value = userVal;
				}
				//else
				//	setProp(parseFloat(userVal), !(userVal.endsWith('.') || userVal.endsWith(',')));
				var name = evt.target.getAttribute("name").substring(2);
			});
		}
		fields = document.getElementsByClassName("copysvfv");
		for (var i = 0; i < fields.length; i++) {
			fields[i].addEventListener("click", function (evt) {
				var id = evt.target.getAttribute("data-id");
				var clientid = evt.target.getAttribute("data-clientid");
				document.getElementById(clientid + "_fv_" + id).value = document.getElementById(clientid + "_list_sv_" + id).value;
			});
		}
	}
};

Tango.registerComponent(AusList, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	listview: listview,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));